export const GET_ADMIN_REQUEST='GET_ADMIN_REQUEST';
export const GET_ADMIN_SUCCESS='GET_ADMIN_SUCCESS';
export const GET_ADMIN_FAIL='GET_ADMIN_FAIL'